import styled, {css} from "styled-components";
import {Text} from "./Shared";
import {solease_cultured, solease_gray_3, solease_red} from "../../constants/Colors";
import {ReactNode, useEffect, useState} from "react";
import StyledInput from "./StyledInput";

const Checkbox = styled('div')<{ active?: boolean }>`
  width: 25px;
  height: 25px;
  background-color: ${solease_cultured};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  border: 1px solid transparent;
  transition: all .3s;

  ${props => props.active && css`
    background-color: ${solease_gray_3};

    &:after {
      content: '';
      display: inline-block;
      transform: rotate(40deg);
      height: 50%;
      width: 25%;
      margin-left: 8px;
      margin-top: 2px;
      border-bottom: 3px solid white;
      border-right: 3px solid white;
      border-radius: 1px;
    }
  `}
`

const Wrapper = styled.div<{ error?: boolean }>`
  width: 100%;
  position: relative;
  margin-bottom: 25px;

  ${Text} {
    margin-bottom: 5px;
  }

  @media (min-width: 900px) {
    max-width: 60%;
  }

  ${Checkbox} {
    border-color: ${props => props.error ? solease_red : 'transparent'};
  }
`

const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 120px;

  ${Checkbox} {
    margin-right: 10px;
  }
`

interface StyledSelectInterface {
    label: string
    additionalContent?: ReactNode
    hasInput?: boolean
    error?: boolean
    onChange: (value: string) => void
}

const StyledSelect = ({label, onChange, additionalContent, hasInput, error}: StyledSelectInterface) => {

    const [selectedOption, setSelectedOption] = useState<string>('')
    const [textInput, setTextInput] = useState('')
    const options = [{label: 'Ja', value: '1'}, {label: 'Nee', value: '2'}]

    const onOptionClicked = (value: string) => setSelectedOption(value)

    //eslint-disable-next-line
    useEffect(() => onChange(hasInput && selectedOption === '1' ? textInput : selectedOption), [selectedOption, textInput])

    return (
        <Wrapper error={error}>
            <Text large>{label}</Text>
            {additionalContent}
            {
                options.map(({label, value}, index) =>
                    <div key={index}>
                        <OptionWrapper
                            onClick={() => onOptionClicked(value)}>
                            <Checkbox active={selectedOption === value}/>
                            <Text>{label}</Text>
                        </OptionWrapper>
                        {
                            hasInput && value === '1' && selectedOption === '1' &&
                            <StyledInput
                                error={error}
                                onChange={(value) => setTextInput(value)} label={''}/>
                        }
                    </div>)
            }
        </Wrapper>
    )
}

export default StyledSelect
